import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { PluginKey } from '@atlaskit/editor-prosemirror/state';
export var toolbarKey = new PluginKey('hyperlinkToolbarItems');
export var toolbarButtonsPlugin = function toolbarButtonsPlugin(initialState) {
  return new SafePlugin({
    key: toolbarKey,
    state: {
      // @ts-ignore - Workaround for help-center local consumption

      init: function init(_, __) {
        return initialState;
      },
      // @ts-ignore - Workaround for help-center local consumption

      apply: function apply(tr, pluginState) {
        var metaState = tr.getMeta(toolbarKey);
        if (metaState) {
          return metaState;
        }
        return pluginState;
      }
    }
  });
};